import { semesters as semestersServices } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../../../../../../../../common/error/state';
import fetchList from './fetchList';
import logger from '../../../../../../../../../../common/services/logService';
import Types from '../types';

export const createItemStart = () => ({
  type: Types.CREATE_ITEM_START,
});

export const createItemEnd = () => ({
  type: Types.CREATE_ITEM_END,
});

export default (semesterId, itemProps, callback) => async dispatch => {
  try {
    dispatch(createItemStart());
    await semestersServices.createStageGradebookDisplays(semesterId, itemProps);
    if (callback) callback();
  } catch (error) {
    logger.log(error);
    if (error.response) {
      dispatch(ErrorsActions.addError(error.response.data.message));
    }
  } finally {
    dispatch(fetchList(semesterId));
    dispatch(createItemEnd());
  }
};
